import React from 'react'
import { useDeleteRequest } from '../../../hooks/request'
import { useModal } from '../../../hooks/modal'
import { getDateTime } from '../../../utils/date'
import { format } from '../../../utils/number'
import Loader from '../../../components/common/Loader'
import BuildingCategoryUpdate from './BuildingCategoryUpdate'
import { BUILDING_CATEGORY_DETAIL } from '../../../urls'

export default function BuildingCategoryItem({ item, category, index }) {
    const brandRemove = useDeleteRequest({ url: BUILDING_CATEGORY_DETAIL.replace('{id}', item.id) })
    const [showUpdateModal, hideUpdateModal] = useModal(
        <BuildingCategoryUpdate
            category={category}
            item={item}
            onSuccess={() => {
                category.request()
                hideUpdateModal()
            }}
            onCancel={() => hideUpdateModal()}
        />,
    )

    async function remove() {
        if (global.confirm('Сизни чинакамдан ўчиришни истайсизми?')) {
            await brandRemove.request()
            await category.request()
        }
    }

    return (
        <tr>
            <td>{index + 1}</td>
            <td>
                {item?.parentName ? `${format(item.parentName)} / ${format(item.name)}` : format(item.name)}
            </td>
            <td>{getDateTime(item.createdAt)}</td>
            <td>
                <div className="is-pulled-right">
                    {!brandRemove.loading ? <i onClick={remove} className="icon pointer ion-md-trash" />
                        : <Loader className="icon" />}

                    <i onClick={showUpdateModal} className="icon pointer ion-md-create" />
                </div>
            </td>
        </tr>
    )
}
